__turbopack_context__.v({
  "container": "BQ2n5q_container",
  "controlsAreHidden": "BQ2n5q_controlsAreHidden",
  "leftSide": "BQ2n5q_leftSide",
  "overlayContainer": "BQ2n5q_overlayContainer",
  "rightSide": "BQ2n5q_rightSide",
});
